<template>
  <router-view />
</template>
<script>
import { throttle } from './tools/common'
export default {
  name: 'App',
  mounted () {
    const rootDom = document.getElementById('root')
    rootDom.setAttribute('style', 'font-size: ' + rootDom.offsetWidth / 375 + 'px')
    window.onresize = throttle(function () {
      rootDom.setAttribute('style', 'font-size: ' + rootDom.offsetWidth / 375 + 'px')
    })
  }
}
</script>

<style lang="scss">
</style>
